import IziGrid from "./IziGrid/IziGrid.vue";
import IziCol from "./IziCol/IziCol.vue";
import IziInput from "./IziInput/IziInput.vue";
import IziCard from "./IziCard/IziCard.vue";
import IziButton from "./IziButton/IziButton.vue";
import IziPage from "./IziPage/IziPage.vue";
import IziIcon from "./IziIcon/IziIcon.vue";
import PIcon from "./pIcon/pIcon.vue";
import IziLayout from "./IziLayout/IziLayout.vue";
import IziDialog from "./IziDialog/IziDialog.vue";

export default [
  {
    name: "IziGrid",
    component: IziGrid
  },
  {
    name: "IziCol",
    component: IziCol
  },
  {
    name: "IziCard",
    component: IziCard
  },
  {
    name: "IziInput",
    component: IziInput
  },
  {
    name: "IziButton",
    component: IziButton
  },
  {
    name: "IziPage",
    component: IziPage
  },
  {
    name: "IziIcon",
    component: IziIcon
  },
  {
    name: "PIcon",
    component: PIcon
  },
  {
    name: "IziLayout",
    component: IziLayout
  },
  {
    name: "IziDialog",
    component: IziDialog
  }
];
